const culture = "cs-CZ";

export namespace StringHelper {
    export function toCurrencyString(amount: number) {
        return new Intl.NumberFormat(culture, { style: "currency", currency: "CZK", maximumSignificantDigits: 10 }).format(amount);
    }

    /** DEPRECATED ? */
    export function toCurrencyFormattedString(number: number, showKC = true, useNbsp = false) {
        let preComma, retVal;

        const stringReverse = function (str: string) {
            return str.split("").reverse().join("");
        };
        const ref = number.toFixed(2).split(".");
        preComma = ref[0];
        const postComma = ref[1];
        preComma = stringReverse(
            stringReverse(preComma)
                .match(/.{1,3}/g)
                // String.fromCharCode(160) - Non-breakable space is char 160
                .join(useNbsp ? String.fromCharCode(160) : " "),
        );
        if (postComma != "00") {
            retVal = preComma + "," + postComma;
        } else {
            retVal = preComma;
        }

        if (showKC) {
            return `${retVal}${useNbsp ? String.fromCharCode(160) : " "}Kč`;
        } else {
            return retVal;
        }
    }

    export function getChanceInflection(numberOfChances?: number) {
        if (numberOfChances == null || numberOfChances == undefined) {
            return "X šancí";
        }
        let chanceInflection = "šancí";
        if (numberOfChances == 1) {
            chanceInflection = "šanci";
        } else if (numberOfChances > 1 && numberOfChances < 5) {
            chanceInflection = "šance";
        }

        return `${numberOfChances} ${chanceInflection}`;
    }
}
